import React from "react";
import { Box, Typography, Grid, InputLabel, Link } from "@mui/material";
import moment from "moment";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { ImagesContext } from "../Context";

interface Props {
  from_date: string;
  to_date: string;
  onChange: (field: "from_date" | "to_date", value: string) => void;
  claimStatus: string;
}

const DatesOfService: React.FC<Props> = ({
  from_date,
  to_date,
  onChange,
  claimStatus,
}) => {
  const fromDate = from_date ? moment(from_date) : null;
  const toDate = to_date ? moment(to_date) : null;

  const images = React.useContext(ImagesContext);
  const [openFromDate, setOpenFromDate] = React.useState<boolean>(false);
  const [openToDate, setOpenToDate] = React.useState<boolean>(false);

  const handleFromDateChange = (date: moment.Moment | null) => {
    onChange("from_date", date ? date.format("YYYY-MM-DD") : "");
  };

  const handleToDateChange = (date: moment.Moment | null) => {
    onChange("to_date", date ? date.format("YYYY-MM-DD") : "");
  };

  return (
    <Grid container spacing={2} alignItems="center" sx={{ minHeight: "160px" }}>
      <Grid item xs={6.5}>
        <Box>
          <Typography
            sx={{
              color: "#A29D9B",
              fontSize: "12px",
              lineHeight: "26px",
              fontWeight: 700,
            }}
          >
            Key Details
          </Typography>
          <p
            style={{
              color: "#707070",
              fontSize: "10px",
              lineHeight: "14px",
              fontWeight: 400,
            }}
          >
            The service dates are automatically set to match the date of the
            associated encounter. You may modify them at your discretion.
          </p>
        </Box>
      </Grid>

      <Grid item xs={5.5}>
        <Box sx={{ marginBottom: "8px" }}>
          <InputLabel
            htmlFor="fromDate"
            sx={{
              color: "#A29D9B",
              fontWeight: 700,
              fontSize: "12px",
              lineHeight: "26px",
            }}
          >
            From Date*
          </InputLabel>
          <Box
            className="field-container"
            sx={{
              marginLeft: "0px",
              backgroundColor: "#efe9e7",
              display: "flex",
              borderRadius: "5px",
              paddingRight: "10.5px",
            }}
          >
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <Box
                className="date-box"
                sx={{
                  width: "88%",
                  maxHeight: 41.13,
                }}
              >
                <DemoContainer components={["DatePicker", "DatePicker"]}>
                  <DatePicker
                    open={openFromDate}
                    onOpen={() => setOpenFromDate(true)}
                    onClose={() => setOpenFromDate(false)}
                    value={fromDate}
                    onChange={(x) => {
                      handleFromDateChange(x);
                    }}
                    format="MM/DD/YYYY"
                    disableOpenPicker
                    disabled={
                      claimStatus === "submitted" ||
                      claimStatus === "pending_submission"
                    }
                    slotProps={{
                      textField: {
                        placeholder: "From Date",
                      },
                      openPickerIcon: images.calendar_icon,
                    }}
                    className="report-date-input no-border-outline"
                    maxDate={null}
                  />
                </DemoContainer>
              </Box>
            </LocalizationProvider>
            <Link
              className="invite-app-user-link"
              onClick={() =>
                claimStatus !== "submitted" &&
                claimStatus !== "pending_submission" &&
                setOpenFromDate(true)
              }
            >
              <img
                src={images.calendar_icon}
                alt="Calendar"
                className="action-icon-image"
                style={{ width: 22.75, maxHeight: 26 }}
              />
            </Link>
          </Box>
        </Box>
        <Box>
          <InputLabel
            htmlFor="fromDate"
            sx={{
              color: "#A29D9B",
              fontWeight: 700,
              fontSize: "12px",
              lineHeight: "26px",
            }}
          >
            To Date*
          </InputLabel>
          <Box
            className="field-container"
            sx={{
              marginLeft: "0px",
              backgroundColor: "#efe9e7",
              display: "flex",
              borderRadius: "5px",
              paddingRight: "10.5px",
            }}
          >
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <Box
                className="date-box"
                sx={{
                  width: "88%",
                  maxHeight: 41.13,
                }}
              >
                <DemoContainer components={["DatePicker", "DatePicker"]}>
                  <DatePicker
                    open={openToDate}
                    onOpen={() => setOpenToDate(true)}
                    onClose={() => setOpenToDate(false)}
                    value={toDate}
                    onChange={(x) => {
                      handleToDateChange(x);
                    }}
                    format="MM/DD/YYYY"
                    disableOpenPicker
                    disabled={
                      claimStatus === "submitted" ||
                      claimStatus === "pending_submission"
                    }
                    slotProps={{
                      textField: {
                        placeholder: "To Date",
                      },
                      openPickerIcon: images.calendar_icon,
                    }}
                    className="report-date-input no-border-outline"
                    maxDate={null}
                  />
                </DemoContainer>
              </Box>
            </LocalizationProvider>
            <Link
              className="invite-app-user-link"
              onClick={() =>
                claimStatus !== "submitted" &&
                claimStatus !== "pending_submission" &&
                setOpenToDate(true)
              }
            >
              <img
                src={images.calendar_icon}
                alt="Calendar"
                className="action-icon-image"
                style={{ width: 22.75, maxHeight: 26 }}
              />
            </Link>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default DatesOfService;
